﻿(function ($) {
    $.fn.ping = function (options) {
        var $opts = jQuery.extend({}, jQuery.fn.ping.defaults, options);

        return this.each(function () {
            var $this = $(this);
            return $this.css("a", $opts.start).animate({
                a: $opts.radius
            },
            {
                duration: $opts.tup,
                step: function (now) {
                    $this.css("text-shadow", "0px 0px " + now + "px " + $opts.color);
                }
            }).animate({
                a: $opts.radius
            }, {
                easing: "linear",
                duration: $opts.tdown,
                step: function (now) {
                    $this.css("text-shadow", "0px 0px " + ($opts.radius - now) + "px " + $opts.color);
                }
            });
        });
    };

    $.fn.ping.defaults = {
        color: "#60f",
        start: 0,
        radius: 15,
        tup: 100,
        tdown: 2000
    };
})(jQuery);

